import moment from 'moment'
import { Form, Row } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { FormLabels, CustomCol } from 'src/components'
import { certificationSections } from './form-content'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { ProjectFormCertificationPayload } from 'src/core/models'
import ProjectFormButtonContinue from '../ProjectFormButtonContinue/ProjectFormButtonContinue'
import {
  setCertificationFormValues,
  projectFormKindSelector,
  certificationFormValues,
  setProjectFormItemValue,
} from 'src/features'


const ProjectFormCertification: React.FC = () => {
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const { t  } = useTranslation()
  const formValues = useAppSelector(certificationFormValues)
  const kindSelected = useAppSelector(projectFormKindSelector)
  const sections = certificationSections(t, kindSelected)

  const onFinish = (values: ProjectFormCertificationPayload) => {
    dispatch(setCertificationFormValues(values))
    dispatch(setProjectFormItemValue({ key: 'activeStep', value: 'DOCUMENTATION' }))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['status']: formValues.status,
      ['type']: formValues.type,
      ['sub_type']: formValues.sub_type,
      ['type_of_biome_ecosystem']: formValues.type_of_biome_ecosystem,
      ['methodology']: formValues.methodology,
      ['validator']: formValues.validator,
      ['mechanism']: formValues.mechanism,
      ['first_verifier']: formValues.first_verifier,
      ['quantification_methodology']: formValues.quantification_methodology,
      ['complementary_standards']: formValues.complementary_standards,
      ['standard']: formValues.standard,
      ['energy_type']: formValues.energy_type,
      ['central_name']: formValues.central_name,
      ['standard_energy_type']: formValues.standard_energy_type,
      ['stage']: formValues.stage,
      ['credit_start']: formValues.credit_start && moment(new Date(formValues.credit_start)),
      ['credit_end']: formValues.credit_end && moment(new Date(formValues.credit_end)),
    })
  }, [form, formValues])

  return (
    <Form
      onFinish={onFinish}
      form={form}
    >
      {sections.map((section, idx) => {
        if (!section.isVisible) return
        return (
          <Row key={idx}>
            <CustomCol>
              <FormLabels {...section.labels}/>
            </CustomCol>

            <CustomCol>
              <section.component />
            </CustomCol>
          </Row>
        )
      })}

      <ProjectFormButtonContinue />
    </Form>
  )
}

export default ProjectFormCertification
